// extracted by css-extract-rspack-plugin
export default {"IssueDetailContainer":"IssueDetail-module__IssueDetailContainer__JnqVq"};